import { MdOutlineCheck } from "react-icons/md";
import { CustomSelectsOption, ISelectedItem } from "./MultiSelectCheck";

interface MultiSelectOptionsListProps {
    options: CustomSelectsOption[];
    selectedItems: ISelectedItem[];
    onSelect: (selected: CustomSelectsOption) => void;
    className?: string;
}

const MultiSelectOptionsList = ({
    options,
    selectedItems,
    onSelect,
    className = 'absolute w-full rounded-sm shadow-custom-dual bg-primary-100 z-[8880] max-h-[200px] mt-1 overflow-y-auto '
}: MultiSelectOptionsListProps) => {
    return (
        <div className={`${className}`} style={{ width: '100%' }}>
            <div className="flex flex-col">
                {options.map((option) => {
                    const isSelected = selectedItems.some(
                        (item) => item.value === option.value
                    );

                    return (
                        <div
                            key={option.id}
                            className={`flex items-center gap-1 text-llarge py-2 px-2 hover:bg-brand-green-1 transition-all duration-200 cursor-pointer 
                                ${isSelected ? "bg-brand-green-5" : ""}
                                ${option.disabled ? "opacity-50 cursor-not-allowed pointer-events-none hover:bg-transparent" : ""}`}
                            onClick={() => {
                                if (option.disabled) return;
                                onSelect(option);
                            }}
                            role="option"
                            aria-selected={isSelected}
                            aria-disabled={option.disabled}
                        >
                            <div className="flex items-center w-[1.125rem] h-[1.125rem]">
                                <MdOutlineCheck
                                    className={`text-system-light-40  ${isSelected ? "opacity-100" : "opacity-0"}`}
                                    size={18}
                                />
                            </div>
                            <span className="truncate max-w-full" title={option.value}>
                                {option.value.trim()}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MultiSelectOptionsList;